var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st68{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 67.59,
    y: 221.31,
    transform: "matrix(0.9861 0.166 -0.166 0.9861 40.2336 -32.3358)",
    className: "st68",
    width: 292,
    height: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M318.28,322.55L84.08,283.13c-12.53-2.11-20.97-13.97-18.86-26.5l8.22-48.81L353,254.87l-8.22,48.81 C342.67,316.21,330.81,324.66,318.28,322.55z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlap);
export default __webpack_public_path__ + "static/media/FLAP.948e4c09e3f60e57ee715a14b7755151.svg";
export { ForwardRef as ReactComponent };